module.exports = __webpack_public_path__ + "img/post-cliente.d7df717e.png";